import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bookmark_border",
  "use": "bookmark_border-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"bookmark_border\">\r\n<path d=\"M5 5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V20L12.4961 16.2835C12.1887 16.1078 11.8113 16.1078 11.5039 16.2835L5 20V5Z\" stroke=\"currentColor\" stroke-width=\"2\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol